module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_65-68de89387e9964a9b7f0022f82884207.png";